const politiqueList = [
    {
        title: "Définition éditoriale",
        details: [
            { label: "Titre", value: "Madatlas" },
            { label: "Sous-titre", value: "Cartes, images et données géographiques de Madagascar, de l’Océan Indien et des Afriques" },
            { label: "ISSN format électronique", value: "En cours de définition" },
            { label: "Périodicité", value: "Au fil de l’eau" },
            { label: "Année de création", value: "2025" },
            { label: "Éditeur", value: "Université de Fianarantsoa" }
        ]
    },
    {
        title: "Politique de droits d’auteur et de diffusion",
        details: [
            { label: "Publication", value: "Publication en libre accès" },
            { label: "Creative Commons", value: "Attribution - Pas d’Utilisation Commerciale - Partage dans les Mêmes Conditions 4.0 International (CC BY-NC-SA 4.0)" },
            { label: "Droits d’auteur", value: "L’auteur ne cède pas ses droits à titre exclusif à la revue" }
        ]
    },
    {
        title: "Politique sur les frais de publication",
        details: [
            { label: "Frais de publication", value: "Non" },
            { label: "Frais de soumission", value: "Non" }
        ]
    },
    {
        title: "Politique d’évaluation",
        details: [
            { label: "Procédure d’évaluation", value: "Évaluation en double aveugle" },
            { label: "Délai moyen entre soumission et publication", value: "À venir" }
        ]
    }
];

export default politiqueList;
